import { Identifiable } from "./Identifiable";
import { OwnerId } from "./User";

export type AnnouncementId = string;

/** Default lifespan: 30 days from createdAt. */
export const ANNOUNCEMENT_DEFAULT_TTL_MS = 30 * 24 * 60 * 60 * 1000;

export interface Announcement extends Identifiable {
  title: string;
  /** Body text. Supports inline `[label](url)` hyperlink syntax via
   *  src/util/renderInlineLinks.tsx. */
  body: string;
  fromOwnerId: OwnerId;
  /** Denormalised display name so the banner can render without
   *  another artist lookup. */
  fromAlias: string;
  createdAt: number;
  /** Epoch ms. After this time the announcement is hidden client-side
   *  and ignored by the active-set query. */
  expiresAt: number;
  /** If false the user cannot dismiss the banner — used for genuine
   *  must-read items. Default true. */
  dismissible: boolean;
}

export interface FreshAnnouncement {
  title: string;
  body: string;
  fromOwnerId: OwnerId;
  fromAlias: string;
  createdAt: number;
  expiresAt: number;
  dismissible: boolean;
}
